import { Data, Research, Scholar, University } from 'component/Common/Icons'

export const offerings = [
  {
    svg: <Data />,
    title: 'Deep dive into emerging tech skills',
  },
  {
    svg: <Research />,
    title: 'Conduct research and create scientific projects & posters',
  },
  {
    svg: <Scholar />,
    title: 'Receive mentorship from faculty, PhDs & industry experts',
  },
  {
    svg: <University />,
    title: 'Increase college competitiveness',
  },
]
